// pages/users/ActiveUsersPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function ActiveUsersPage() {
  return <UserRolePage title="Active Users" accentColor="#10b981"
    initialFilters={{ status:'Active' }} />;
}
